import { render, staticRenderFns } from "./send-payment.vue?vue&type=template&id=4e3fddde&scoped=true&"
import script from "./send-payment.vue?vue&type=script&lang=js&"
export * from "./send-payment.vue?vue&type=script&lang=js&"
import style0 from "./send-payment.vue?vue&type=style&index=0&id=4e3fddde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3fddde",
  null
  
)

export default component.exports